// gift.component.ts
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';


interface Gift {
    id?: string;  // 可選，因為新增時可能還沒有 ID
    name: string;
    image: string;
    category: string;
    category_name: string;
    category_parent_id: string;
    category_parent_name: string;
    cost_diamond: string;
    convert_diamond: string;
    exchange_count: string;
    exchange_limit: string;
    buy_limit: string;
    expire: string;
    status: string;
    stock: string;
    sort: string;
    create_dt: string;
    update_dt: string;
}

interface ApiResponse {
    status: boolean;
    message: string;
    data: Gift[];
    category: any[];
}

interface Category {
    id?: number;         // ← 修改時才會有
    parent_id: string;
    name: string;
    sort: string;
    status: string;
}


// gift.component.ts - 新增兌換申請單相關功能

// 在現有的 interface 區塊後新增
interface RedemptionOrder {
    id: string;
    user_id: string;
    real_gift_id: string;
    num: string;
    name: string;
    phone: string;
    type: string;
    address: string;
    status: string;
    create_dt: string;
    update_dt: string;
    gitf_name: string;  // API 回傳的拼字
    image: string;
    user_name: string;
    user_phone_num: string;
    profile_pic: string;
}

interface RedemptionApiResponse {
    status: boolean;
    message: string;
    data: RedemptionOrder[];
}
@Component({
    selector: 'app-gift',
    templateUrl: './gift.component.html',
    styleUrls: ['./gift.component.css']
})
export class GiftComponent implements OnInit {
    loading: boolean = true;
    gifts: Gift[] = [];
    filteredGifts: Gift[] = [];
    searchTerm: string = '';
    selectedCategory: string = 'all';
    viewMode: 'grid' | 'list' = 'grid';
    categories: any[] = [];

    // 統一的彈窗相關
    showGiftModal: boolean = false;  // 統一的彈窗狀態
    isEditMode: boolean = false;     // 區分編輯或新增模式
    editingGift: Gift | null = null;
    editForm: any = {
        id: '',
        name: '',
        category: '',
        cost_diamond: '',
        convert_diamond: '',
        stock: '',
        exchange_count: '',
        exchange_limit: '',
        buy_limit: '',
        expire: '',
        status: '1',
        image: ''
    };

    // 圖片上傳相關
    selectedFile: File | null = null;
    imagePreviewUrl: string | null = null;
    isUploading: boolean = false;

    showCategoryModal = false;
    categoryList: any[] = [];
    newCategory: Category = {
      parent_id: "0",
      name: "",
      sort: "0",
      status: "0"
    };


    // 狀態切換
    isAddingCategory = false;

    //操作類型更換 0:新增 1:修改
    typeChange = 0;

    // 新增兌換申請單相關屬性
    showRedemptionModal: boolean = false;
    redemptionOrders: RedemptionOrder[] = [];
    filteredRedemptionOrders: RedemptionOrder[] = [];
    redemptionLoading: boolean = false;
    redemptionSearchTerm: string = '';
    selectedRedemptionStatus: string = 'all';
    redemptionViewMode: 'grid' | 'list' = 'list';

    // 狀態選項
    redemptionStatusOptions = [
        { value: 'all', label: '全部', count: 0 },
        { value: '-1', label: '已取消', count: 0 },
        { value: '0', label: '待處理', count: 0 },
        { value: '1', label: '已完成', count: 0 },
        { value: '2', label: '已寄出', count: 0 }
    ];

    // 兌換申請單詳細資訊
    selectedRedemptionOrder: RedemptionOrder | null = null;
    showRedemptionDetailModal: boolean = false;

    // 編輯相關屬性
    showEditRedemptionModal: boolean = false;
    editingRedemptionOrder: RedemptionOrder | null = null;
    editRedemptionForm: any = {
        id: '',
        name: '',
        phone: '',
        type: '0',
        address: '',
        status: '0'
    };
    isUpdatingRedemption: boolean = false;

    // 狀態選項
    allStatusOptions = [
        { value: '0', label: '待處理' },
        { value: '1', label: '處理中' },
        { value: '2', label: '已寄出' },
        { value: '3', label: '已完成' },
        { value: '-1', label: '已取消' }
    ];

    // 配送方式選項
    deliveryTypeOptions = [
        { value: '0', label: '宅配' },
        // { value: '1', label: '超商取貨' },
        { value: '1', label: '現場取貨' }
    ];

    // 在禮物分類相關屬性附近加入
    categoryStatusFilter: string = 'all';
    filteredCategoryList: any[] = [];

    activeCount = 0;
    inactiveCount = 0;

    constructor(
        public httpClient: HttpClient,
    ) {}

    /**
    * 篩選分類狀態
    */
    filterCategoryByStatus(status: string) {
        this.categoryStatusFilter = status;
        this.applyStatusFilter();
    }

    /**
    * 應用狀態篩選
    */
    applyStatusFilter() {
        if (this.categoryStatusFilter === 'all') {
            this.filteredCategoryList = [...this.categoryList];
        } else {
            this.filteredCategoryList = this.categoryList.filter(cat =>
                cat.status.toString() === this.categoryStatusFilter
            );
        }
    }


    /**
     * 開啟兌換申請單管理
     */
    openRedemptionManagement() {
        this.showRedemptionModal = true;
        this.loadRedemptionOrders();
    }

    /**
     * 關閉兌換申請單管理
     */
    closeRedemptionModal() {
        this.showRedemptionModal = false;
        this.redemptionOrders = [];
        this.filteredRedemptionOrders = [];
        this.redemptionSearchTerm = '';
        this.selectedRedemptionStatus = 'all';
    }

    /**
     * 載入兌換申請單資料
     */
    loadRedemptionOrders() {
        this.redemptionLoading = true;
        const body = {};

        this.httpClient.post<RedemptionApiResponse>("/real_gift/get_gift_redemption_order.php", body)
            .subscribe({
                next: (res) => {
                    this.redemptionLoading = false;
                    if (res.status) {
                        this.redemptionOrders = res.data || [];
                        this.updateStatusCounts();
                        this.filterRedemptionOrders();
                        console.log('兌換申請單載入成功:', this.redemptionOrders);
                    } else {
                        console.error('API Error:', res.message);
                        alert('載入兌換申請單失敗：' + res.message);
                    }
                },
                error: (error) => {
                    this.redemptionLoading = false;
                    console.error('HTTP Error:', error);
                    alert('載入兌換申請單失敗：網路錯誤');
                }
            });
    }

    /**
     * 更新狀態統計
     */
    updateStatusCounts() {
        this.redemptionStatusOptions[0].count = this.redemptionOrders.length; // 全部
        this.redemptionStatusOptions[1].count = this.redemptionOrders.filter(order => order.status === '-1').length; // 已取消
        this.redemptionStatusOptions[2].count = this.redemptionOrders.filter(order => order.status === '0').length; // 待處理
        this.redemptionStatusOptions[3].count = this.redemptionOrders.filter(order => order.status === '1').length; // 已完成
        this.redemptionStatusOptions[4].count = this.redemptionOrders.filter(order => order.status === '2').length; // 已寄出
    }

    /**
     * 篩選兌換申請單
     */
    filterRedemptionOrders() {
        this.filteredRedemptionOrders = this.redemptionOrders.filter(order => {
            const matchesSearch = !this.redemptionSearchTerm ||
                order.gitf_name.toLowerCase().includes(this.redemptionSearchTerm.toLowerCase()) ||
                order.user_name.toLowerCase().includes(this.redemptionSearchTerm.toLowerCase()) ||
                order.name.toLowerCase().includes(this.redemptionSearchTerm.toLowerCase()) ||
                order.phone.includes(this.redemptionSearchTerm);

            const matchesStatus = this.selectedRedemptionStatus === 'all' ||
                order.status === this.selectedRedemptionStatus;

            return matchesSearch && matchesStatus;
        });

        // 按建立時間排序（最新的在前）
        this.filteredRedemptionOrders.sort((a, b) =>
            new Date(b.create_dt).getTime() - new Date(a.create_dt).getTime()
        );
    }

    /**
     * 按狀態篩選
     */
    filterByRedemptionStatus(status: string) {
        this.selectedRedemptionStatus = status;
        this.filterRedemptionOrders();
    }

    /**
     * 取得狀態文字
     */
    getRedemptionStatusText(status: string): string {
        const statusMap: { [key: string]: string } = {
            '-1': '已取消',
            '0': '待處理',
            '1': '已完成',
            '2': '已寄出'
        };
        return statusMap[status] || '未知';
    }

    /**
     * 取得狀態樣式
     */
    getRedemptionStatusClass(status: string): string {
        const statusClassMap: { [key: string]: string } = {
            '-1': 'status-rejected',
            '0': 'status-pending',
            '1': 'status-completed'
        };
        return statusClassMap[status] || 'status-unknown';
    }

    /**
     * 取得配送方式文字
     */
    getDeliveryTypeText(type: string): string {
        return type === '0' ? '宅配' : '其他';
    }

    /**
     * 檢視兌換申請單詳情
     */
    viewRedemptionDetails(order: RedemptionOrder) {
        this.selectedRedemptionOrder = order;
        this.showRedemptionDetailModal = true;
    }

    /**
     * 關閉詳情彈窗
     */
    closeRedemptionDetailModal() {
        this.showRedemptionDetailModal = false;
        this.selectedRedemptionOrder = null;
    }

    /**
     * 更新申請單狀態
     */
    updateRedemptionStatus(orderId: string, newStatus: string, reason?: string) {
        const statusText = this.getRedemptionStatusText(newStatus);

        if (!confirm(`確定要將此申請單狀態改為「${statusText}」嗎？`)) {
            return;
        }

        const updateData = {
            id: orderId,
            status: newStatus,
            reason: reason || ''
        };

        // 這裡需要實際的更新 API
        // this.httpClient.post('/real_gift/update_redemption_status.php', updateData)
        //     .subscribe(res => {
        //         if (res.status) {
        //             this.loadRedemptionOrders(); // 重新載入數據
        //             if (this.showRedemptionDetailModal) {
        //                 this.closeRedemptionDetailModal();
        //             }
        //             alert('狀態更新成功');
        //         } else {
        //             alert('狀態更新失敗：' + res.message);
        //         }
        //     });

        // 暫時模擬更新成功
        const orderIndex = this.redemptionOrders.findIndex(o => o.id === orderId);
        if (orderIndex !== -1) {
            this.redemptionOrders[orderIndex].status = newStatus;
            this.redemptionOrders[orderIndex].update_dt = new Date().toISOString().slice(0, 19).replace('T', ' ');
            this.updateStatusCounts();
            this.filterRedemptionOrders();
            if (this.showRedemptionDetailModal && this.selectedRedemptionOrder) {
                this.selectedRedemptionOrder.status = newStatus;
            }
            alert('狀態更新成功');
        }
    }

    /**
     * 批次處理選中的申請單
     */
    batchUpdateRedemptionStatus(orderIds: string[], status: string) {
        if (!orderIds.length) {
            alert('請先選擇要處理的申請單');
            return;
        }

        const statusText = this.getRedemptionStatusText(status);
        if (!confirm(`確定要批次將 ${orderIds.length} 筆申請單狀態改為「${statusText}」嗎？`)) {
            return;
        }

        // 實際應該呼叫批次更新 API
        // 暫時模擬批次更新
        orderIds.forEach(orderId => {
            const orderIndex = this.redemptionOrders.findIndex(o => o.id === orderId);
            if (orderIndex !== -1) {
                this.redemptionOrders[orderIndex].status = status;
                this.redemptionOrders[orderIndex].update_dt = new Date().toISOString().slice(0, 19).replace('T', ' ');
            }
        });

        this.updateStatusCounts();
        this.filterRedemptionOrders();
        alert(`批次更新 ${orderIds.length} 筆申請單成功`);
    }

    /**
     * 匯出兌換申請單
     */
    exportRedemptionOrders() {
        if (!this.filteredRedemptionOrders.length) {
            alert('沒有資料可匯出');
            return;
        }

        // 準備匯出資料
        const exportData = this.filteredRedemptionOrders.map(order => ({
            '申請單ID': order.id,
            '禮物名稱': order.gitf_name,
            '申請人': order.user_name,
            '聯絡電話': order.user_phone_num,
            '收件人': order.name,
            '收件電話': order.phone,
            '配送地址': order.address,
            '配送方式': this.getDeliveryTypeText(order.type),
            '申請數量': order.num,
            '狀態': this.getRedemptionStatusText(order.status),
            '申請時間': order.create_dt,
            '更新時間': order.update_dt
        }));

        // 轉換為 CSV
        const csvContent = this.convertToCSV(exportData);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

        // 下載檔案
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `禮物兌換申請單_${new Date().toISOString().slice(0, 10)}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
    }

    /**
     * 轉換為 CSV 格式
     */
    private convertToCSV(data: any[]): string {
        if (!data.length) return '';

        const headers = Object.keys(data[0]);
        const csvHeaders = headers.join(',');

        const csvRows = data.map(row =>
            headers.map(header => {
                const value = row[header];
                return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
            }).join(',')
        );

        return [csvHeaders, ...csvRows].join('\n');
    }

    /**
     * 重新整理兌換申請單
     */
    refreshRedemptionOrders() {
        this.loadRedemptionOrders();
    }

    /**
     * 追蹤函數
     */
    trackByRedemptionId(index: number, order: RedemptionOrder): string {
        return order.id;
    }

    openAddCategoryForm() {
        this.isAddingCategory = true;
        this.typeChange = 0;
        this.newCategory = {
            parent_id: '0',
            name: '',
            sort: "0",
            status: "0",
        };
    }

    cancelAddCategory() {
        this.isAddingCategory = false;
    }

    submitNewCategory() {
        this.httpClient.post<ApiResponse>("/real_gift/set_real_gift_category.php", this.newCategory).subscribe((res) => {
            if (res.status) {
                if (this.newCategory.id) {
                    alert("修改成功");
                } else {
                    alert("新增成功");
                }
                this.isAddingCategory = false;
                this.giftCategory(); // 重新載入分類列表
            } else {
                if (this.newCategory.id) {
                    alert("修改失敗: " + res.message);
                } else {
                    alert("新增失敗: " + res.message);
                }
            }},(error) => {
                console.error("HTTP Error:", error);
                alert("系統錯誤，請稍後再試");
            }
        );
    }



    ngOnInit(): void {
        this.init_list();
    }

    updateCounts() {
        console.log('updateCounts',this.categoryList);
        this.activeCount = this.categoryList.filter(cat => cat.status == 1).length;
        this.inactiveCount = this.categoryList.filter(cat => cat.status == 0).length;
    }

    init_list() {
        this.loading = true;
        const body = {};
        this.httpClient.post<ApiResponse>("/real_gift/get_real_gift.php", body).subscribe(res => {
            this.loading = false;
            if (res.status) {
                this.gifts = res.data || [];
                console.log('gifts',this.gifts);
                this.filteredGifts = [...this.gifts];

                this.categories = res.category;
;

                // this.extractCategories();
                console.log('禮物資料載入成功:', this.gifts);
            } else {
                console.error('API Error:', res.message);
            }
        }, error => {
            this.loading = false;
            console.error('HTTP Error:', error);
        });
    }

    editCategory(cat: any) {
        this.typeChange = 1;
        this.isAddingCategory = true;
        this.newCategory = { ...cat }; // 複製資料到表單
    }

    deleteCategory(cat: any) {
        if (confirm('確定要刪除這個分類嗎？')) {
            this.newCategory = cat;
            console.log('this.newCategory',this.newCategory);
            this.newCategory.status = '-1';
            this.httpClient.post<ApiResponse>("/real_gift/set_real_gift_category.php", this.newCategory).subscribe((res) => {
                if (res.status) {
                    alert("刪除成功");
                    this.giftCategory(); // 重新載入分類列表
                } else {
                    alert("刪除失敗: " + res.message);
                }},(error) => {
                    console.error("HTTP Error:", error);
                    alert("系統錯誤，請稍後再試");
                }
            );
        }
    }

    giftCategory() {
        const body = {};
        this.httpClient.post<any>("/real_gift/get_real_gift_category.php", body).subscribe(
            res => {
                if (res.status) {
                    const list = Object.values(res.data).filter((cat: any) => cat.id);
                    this.categoryList = this.flattenCategory(list);
                    this.applyStatusFilter(); // 新增這行
                    this.updateCounts();
                    this.showCategoryModal = true;
                } else {
                    alert("取得分類失敗：" + res.message);
                }
            },
            error => {
                console.error("HTTP Error:", error);
            }
        );
    }

    // 將巢狀資料展平並加上層級
    flattenCategory(list: any[], level: number = 0, parentId: string = "0"): any[] {
        let result: any[] = [];
        list.filter(cat => cat.parent_id === parentId).forEach(cat => {
            result.push({ ...cat, level });
            if (cat.son) {
                const children = Object.values(cat.son);
                result = result.concat(this.flattenCategory(children, level + 1, cat.id));
            }
        });
        return result;
    }

    // 展開/收合不用，因為用 flatten 顯示
    toggleExpand(cat: any) {
        cat.expanded = !cat.expanded;
    }

    addNewCategory() {
        this.loading = true;
        const body = {};
        this.httpClient.post<ApiResponse>("/real_gift/get_real_gift_category.php", body).subscribe(res => {
            this.loading = false;
           if (res.status) {
                    // 把物件轉成陣列 (只取有 id 的)
                    this.categoryList = Object.values(res.data).filter(
                        (cat: any) => cat.id
                    );
                    this.showCategoryModal = true;
                } else {
                    alert('取得分類失敗: ' + res.message);
            }
        }, error => {
            this.loading = false;
            console.error('HTTP Error:', error);
        });

    }

    closeCategoryModal() {
        this.showCategoryModal = false;
        this.isAddingCategory = false;
        this.categoryStatusFilter = 'all'; // 重置篩選
    }

    extractCategories() {
        const categoryMap = new Map();
        this.gifts.forEach(gift => {
            if (!categoryMap.has(gift.category)) {
                categoryMap.set(gift.category, {
                    id: gift.category,
                    name: gift.category_name,
                    parent_name: gift.category_parent_name
                });
            }
        });
        this.categories = Array.from(categoryMap.values());
        console.log('categories',this.categories);
    }

    filterGifts() {
        this.filteredGifts = this.gifts.filter(gift => {
            const matchesSearch = !this.searchTerm ||
                gift.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                gift.category_name.toLowerCase().includes(this.searchTerm.toLowerCase());
            const matchesCategory = this.selectedCategory === 'all' ||
                gift.category === this.selectedCategory;

            return matchesSearch && matchesCategory;
        });
    }

    filterByCategory(categoryId: string) {
        this.selectedCategory = categoryId;
        this.filterGifts();
    }

    getGiftCountByCategory(categoryId: string): number {
        return this.gifts.filter(gift => gift.category === categoryId).length;
    }

    getStatusText(status: string): string {
        return status === '1' ? '啟用' : '停用';
    }

    getStatusClass(status: string): string {
        return status === '1' ? 'active' : 'inactive';
    }

    getExchangeLimit(limit: string): string {
        const num = parseInt(limit);
        return num >= 999999999 ? '無限制' : limit;
    }

    formatDate(dateString: string): string {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('zh-TW', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        } catch {
            return dateString.split(' ')[0] || dateString;
        }
    }

    private numberFormatter = new Intl.NumberFormat('zh-TW');

    numberToThousand(str: string | number): string {
        if (!str) return '0';
        return this.numberFormatter.format(Number(str));
    }

    trackByGiftId(index: number, gift: Gift): string {
        return gift.id;
    }

    onImageLoad(event: any) {
        console.log('圖片載入成功:', event.target.src);
    }

    onImageError(event: any) {
        console.error('圖片載入失敗:', event.target.src);
        event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0zNS41IDQ1LjVMMzUuNSA0NS41QzM1LjUgNDUuNSAzNS41IDQ1LjUgMzUuNSA0NS41WiIgZmlsbD0iIzlDQTNBRiIvPgo8L3N2Zz4K';
    }

    // 編輯禮物
    editGift(gift: Gift) {
        this.isEditMode = true;
        this.editingGift = { ...gift };
        this.editForm = {
            id: gift.id,
            name: gift.name,
            category: gift.category,
            cost_diamond: gift.cost_diamond,
            convert_diamond: gift.convert_diamond,
            stock: gift.stock,
            exchange_count: gift.exchange_count,
            exchange_limit: gift.exchange_limit,
            buy_limit: gift.buy_limit,
            expire: gift.expire,
            status: gift.status,
            image: gift.image
        };
        this.imagePreviewUrl = gift.image;
        this.selectedFile = null;
        this.showGiftModal = true;
    }


    // 新增禮物
    addNewGift() {
        this.isEditMode = false;
        this.editingGift = null;
        this.editForm = {
            id: '',
            name: '',
            category: '',
            cost_diamond: '0',
            convert_diamond: '0',
            stock: '1',
            exchange_count: '1',
            exchange_limit: '999999999',
            buy_limit: '999999999',
            expire: '30',
            status: '1',
            image: ''
        };
        this.selectedFile = null;
        this.imagePreviewUrl = null;
        this.showGiftModal = true;
    }

    // 關閉彈窗
    closeGiftModal() {
        this.showGiftModal = false;
        this.isEditMode = false;
        this.editingGift = null;
        this.selectedFile = null;
        this.imagePreviewUrl = null;
        this.isUploading = false;
        this.editForm = {
            id: '',
            name: '',
            category: '',
            cost_diamond: '',
            convert_diamond: '',
            stock: '',
            exchange_count: '',
            exchange_limit: '',
            buy_limit: '',
            expire: '',
            status: '1',
            image: ''
        };
    }

    // 圖片選擇
    onFileSelected(event: any) {
        const file = event.target.files[0];
        if (file) {
            if (!file.type.startsWith('image/')) {
                alert('請選擇圖片檔案');
                event.target.value = '';
                return;
            }

            if (file.size > 5 * 1024 * 1024) {
                alert('圖片檔案不能超過 5MB');
                event.target.value = '';
                return;
            }

            this.selectedFile = file;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imagePreviewUrl = e.target.result;
                console.log('圖片預覽 URL 已設定:', this.imagePreviewUrl);
            };
            reader.onerror = () => {
                alert('圖片讀取失敗，請重新選擇');
                this.selectedFile = null;
                this.imagePreviewUrl = this.isEditMode && this.editingGift ? this.editingGift.image : null;
            };
            reader.readAsDataURL(file);
        }
    }

    // 重置圖片
    resetImage() {
        this.selectedFile = null;
        if (this.isEditMode && this.editingGift) {
            this.imagePreviewUrl = this.editingGift.image;
        } else {
            this.imagePreviewUrl = null;
        }
    }

    // 上傳圖片
    uploadImage(): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!this.selectedFile) {
                resolve(this.editForm.image);
                return;
            }

            this.isUploading = true;
            setTimeout(() => {
                this.isUploading = false;
                if (this.imagePreviewUrl) {
                    resolve(this.imagePreviewUrl);
                } else {
                    reject('圖片處理失敗');
                }
            }, 300);
        });
    }

    // 統一的保存方法
    async saveGift() {
        if (!this.validateGiftForm()) {
            return;
        }

        try {
            const imageUrl = await this.uploadImage();

            if (this.isEditMode) {

                // 編輯模式
                const updateData = {
                    ...this.editForm,
                    image: imageUrl,
                    update_dt: new Date().toISOString().slice(0, 19).replace('T', ' ')
                };


                console.log('更新禮物資料:', updateData);

                this.httpClient.post('/real_gift/set_real_gift.php', updateData).subscribe((res: any) => {
                    if (res.status) {
                        const index = this.gifts.findIndex(g => g.id === updateData.id);
                        if (index !== -1) {
                            this.gifts[index] = { ...this.gifts[index], ...updateData };
                            this.filterGifts();
                        }
                        this.closeGiftModal();
                        alert('更新成功！');
                    } else {
                        alert('更新失敗：' + res.message);
                    }
                }, error => {
                    console.error('更新錯誤:', error);
                    alert('更新失敗：網路錯誤');
                });
            } else {
                // 新增模式

                const newGift: Gift = {
                    name: this.editForm.name,
                    category: this.editForm.category,
                    category_name: this.getCategoryName(this.editForm.category),
                    category_parent_id: this.getCategoryParentId(this.editForm.category),
                    category_parent_name: this.getCategoryParentName(this.editForm.category),
                    cost_diamond: this.editForm.cost_diamond,
                    convert_diamond: this.editForm.convert_diamond,
                    stock: this.editForm.stock,
                    exchange_count: this.editForm.exchange_count,
                    exchange_limit: this.editForm.exchange_limit,
                    buy_limit: this.editForm.buy_limit,
                    expire: this.editForm.expire,
                    status: this.editForm.status,
                    sort: '0',
                    image: imageUrl,
                    create_dt: new Date().toISOString().slice(0, 19).replace('T', ' '),
                    update_dt: new Date().toISOString().slice(0, 19).replace('T', ' ')
                };

                console.log('新增禮物資料:', newGift);

                // TODO: 新增 API
                this.httpClient.post('/real_gift/set_real_gift.php', newGift).subscribe((res: any) => {
                    if (res.status) {
                        this.closeGiftModal();
                        alert('更新成功！');
                    } else {
                        alert('更新失敗：' + res.message);
                    }
                }, error => {
                    console.error('更新錯誤:', error);
                    alert('更新失敗：網路錯誤');
                });


                // 暫時直接添加到本地數據
                this.gifts.unshift(newGift);
                this.filterGifts();
            }

        } catch (error) {
            alert((this.isEditMode ? '更新' : '新增') + '失敗：' + error);
        }
    }

    // 表單驗證
    validateGiftForm(): boolean {
        if (!this.editForm.name.trim()) {
            alert('請輸入禮物名稱');
            return false;
        }
        if (!this.isEditMode && !this.editForm.category) {
            alert('請選擇分類');
            return false;
        }
        if (!this.editForm.cost_diamond || parseFloat(this.editForm.cost_diamond) < 0) {
            alert('請輸入有效的消費鑽石數');
            return false;
        }
        if (!this.editForm.stock || parseInt(this.editForm.stock) < 0) {
            alert('請輸入有效的庫存數量');
            return false;
        }
        if (!this.editForm.expire || parseInt(this.editForm.expire) <= 0) {
            alert('請輸入有效的有效期限');
            return false;
        }
        if (!this.isEditMode && !this.selectedFile && !this.imagePreviewUrl) {
            alert('請選擇禮物圖片');
            return false;
        }
        return true;
    }

    // 輔助方法
    getCategoryName(categoryId: string): string {
        const category = this.categories.find(cat => cat.id === categoryId);
        return category ? category.name : '';
    }

    getCategoryParentId(categoryId: string): string {
        const category = this.categories.find(cat => cat.id === categoryId);
        return category ? '1' : '';
    }

    getCategoryParentName(categoryId: string): string {
        const category = this.categories.find(cat => cat.id === categoryId);
        return category ? category.parent_name || '預設分類' : '';
    }

    formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    onModalBackdropClick(event: Event) {
        if (event.target === event.currentTarget) {
            this.closeGiftModal();
        }
    }

    toggleStatus(gift: Gift) {
        const newStatus = gift.status === '1' ? '0' : '1';
        const action = newStatus === '1' ? '啟用' : '停用';

        if (confirm(`確定要${action} "${gift.name}" 嗎？`)) {
            console.log(`切換 ${gift.name} 狀態從 ${this.getStatusText(gift.status)} 到 ${this.getStatusText(newStatus)}`);
            gift.status = newStatus;
            this.editForm = gift;
            this.imagePreviewUrl = this.editForm.image;
            this.isEditMode = true;
            this.saveGift();
        }
    }

    deleteGift(gift: Gift) {
        if (confirm(`確定要刪除 "${gift.name}" 嗎？此操作無法復原。`)) {
            console.log('刪除禮物:', gift);
            this.gifts = this.gifts.filter(g => g.id !== gift.id);
            this.filterGifts();
            gift.status = '-1';
            this.editForm = gift;
            this.imagePreviewUrl = this.editForm.image;
            this.isEditMode = true;
            this.saveGift();
        }
    }

    refreshList() {
        this.init_list();
    }

    // 向後相容的方法
    closeEditModal() {
        this.closeGiftModal();
    }

    /**
    * 開啟編輯申請單彈窗
    */
    editRedemptionOrder(order: RedemptionOrder) {
        this.editingRedemptionOrder = { ...order };
        this.editRedemptionForm = {
            id: order.id,
            name: order.name,
            phone: order.phone,
            type: order.type,
            address: order.address,
            status: order.status
        };
        this.showEditRedemptionModal = true;
    }

    /**
    * 關閉編輯彈窗
    */
    closeEditRedemptionModal() {
        this.showEditRedemptionModal = false;
        this.editingRedemptionOrder = null;
        this.isUpdatingRedemption = false;
    }

    /**
    * 儲存修改
    */
    saveEditedRedemptionOrder() {
        if (!this.editRedemptionForm.name.trim()) {
            alert('請輸入收件人姓名');
            return;
        }
        if (!this.editRedemptionForm.phone.trim()) {
            alert('請輸入聯絡電話');
            return;
        }
        if (!this.editRedemptionForm.address.trim()) {
            alert('請輸入配送地址');
            return;
        }

        this.isUpdatingRedemption = true;

        this.httpClient.post('/real_gift/set_gift_redemption_order.php', this.editRedemptionForm).subscribe((res: any) => {
            this.isUpdatingRedemption = false;
            if (res.status) {
                // 更新本地數據
                const orderIndex = this.redemptionOrders.findIndex(o => o.id === this.editRedemptionForm.id);
                if (orderIndex !== -1) {
                    Object.assign(this.redemptionOrders[orderIndex], this.editRedemptionForm);
                    this.redemptionOrders[orderIndex].update_dt = new Date().toISOString().slice(0, 19).replace('T', ' ');
                }
                this.updateStatusCounts();
                this.filterRedemptionOrders();
                this.closeEditRedemptionModal();
                alert('修改成功！');
            } else {
                alert('修改失敗：' + res.message);
            }
        }, error => {
            this.isUpdatingRedemption = false;
            alert('修改失敗：網路錯誤');
        });

    }
}
